import { render, staticRenderFns } from "./BreadCrumbDigest.vue?vue&type=template&id=9d8b375a&scoped=true"
import script from "./BreadCrumbDigest.vue?vue&type=script&lang=js"
export * from "./BreadCrumbDigest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d8b375a",
  null
  
)

export default component.exports